export const formRegranulat = () => {
  const isSingle = document.querySelector(".single-regranulat");
  if (isSingle) {
    // Pobierz wszystkie inputy i spany z regranulat (mogą być 2 formularze na stronie)
    const inputs = document.querySelectorAll('input[id="regranulat"]');
    const spans = document.querySelectorAll(".cf7-form__field--regranulat > p");
    
    if (typeof regranulat !== "undefined") {
      // Ustaw wartość dla wszystkich znalezionych elementów
      inputs.forEach((input) => {
        input.value = regranulat;
      });
      spans.forEach((span) => {
        span.textContent = regranulat;
      });
    }
  }
};
